import { getPublicBranding, publicBrandingQueryKey } from "@/api";
import type { Branding } from "@/contracts";
import { queryClient } from "@/lib/query-client";
import { useQuery } from "@tanstack/react-query";

type Brand = Pick<Branding, "logo" | "images" | "settings" | "texts" | "colors">;

export function useAppLoadingData({ host, brand }: { host: string; brand: Brand | undefined }) {
  return useQuery(
    {
      queryKey: publicBrandingQueryKey(host),
      queryFn: () => getPublicBranding(host),
      enabled: !brand,
      retry: false,
      staleTime: 5 * 60 * 1000,
    },
    queryClient,
  );
}
